// JSON-style field configuration
export const RFQformFields = [
  {
    name: "industry",
    type: "select",
    label: "Industry *",
    placeholder: "Select industry",
    options: [
      "Manufacturing",
      "Technology",
      "Healthcare",
      "Automotive",
      "Electronics",
      "Construction",
      "Food & Beverage",
      "Textiles",
    ],
  },
  {
    name: "productCategory",
    type: "select",
    label: "Product Category",
    placeholder: "Select category",
    options: [
      "Raw Materials",
      "Components",
      "Equipment",
      "Services",
      "Software",
      "Packaging",
    ],
  },
  {
    name: "subProductCategory",
    type: "select",
    label: "Sub-Product Category",
    placeholder: "Select sub-category",
    options: [
      "Metal Components",
      "Plastic Parts",
      "Electronic Components",
      "Software Licenses",
      "Consultation Services",
      "Quality Assurance",
    ],
  },
  {
    name: "leadName",
    type: "text",
    label: "Lead Name *",
    placeholder: "Enter lead name",
  },
  {
    name: "quantity",
    type: "number",
    label: "Quantity",
    placeholder: "Enter quantity",
  },
  {
    name: "description",
    type: "textarea",
    label: "Description *",
    placeholder: "Provide detailed description...",
  },

  // 🔹 File Upload Fields
  {
    name: "uploadImages",
    type: "file",
    label: "Upload Images",
    multiple: true,
    maxSizeMB: 5,
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
  },
  {
    name: "uploadVideos",
    type: "file",
    label: "Upload Videos",
    multiple: true,
    maxSizeMB: 50,
    accept: {
      "video/mp4": [],
      "video/quicktime": [],
    },
  },
  {
    name: "uploadPDFs",
    type: "file",
    label: "Upload PDFs",
    multiple: true,
    maxSizeMB: 10,
    accept: {
      "application/pdf": [],
    },
  },
];
